import React, { useState, useEffect ,useContext} from "react";
import { Link } from "react-router-dom";
import socketIOClient from "socket.io-client";
import { authContext } from "../../Context/AuthContext";
import "./chatbar.css";


const ChatBar = () => {
  const [message, setMessage] = useState("");
  const [chatMessages, setChatMessages] = useState([]);
  const {  email, } = useContext(authContext);
  const socket = socketIOClient("http://localhost:7890", { transports: ["websocket"] });
  //const socket = io("http://localhost:7890/", { transports: ["websocket"] })

  useEffect(() => {
    return () => {
      socket.disconnect();
    };
  }, [socket]);

  socket.on("messageget", (newMessage) => {
    console.log(newMessage)
    setChatMessages((prevMessages) => [...prevMessages, newMessage]);
  });
  
  const handleInputChange = (e) => {
    setMessage(e.target.value);
  };
  
  const handleSendMessage = () => {

    if (message.trim() !== "") {
      socket.emit("message", {data:message,sender:email});
      setMessage("");
    }
  };

  return (
    <div className="chat-bar">
      <div className="chat-container">
        <div className="chat-messages">
          {chatMessages.map((msg, index) => (
            <div key={index} className="chat-message">
              {msg.data}
              {msg.sender}
            </div>
          ))}
        </div>
        <div className="chat-input">
          <input
            type="text"
            placeholder="Type your message..."
            value={message}
            onChange={handleInputChange}
          />
          <button onClick={handleSendMessage}>Send</button>
        </div>
      </div>
    </div>
  );
};

export default ChatBar;
